import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon, IconSize } from 'app/components/core/Icon';
import * as styles from './SnowflakeConnectionModal.css';

export function SnowflakeUserInfo({ user = null, account = null }) {
    const { t } = useTranslation();
    const userFallback = t('common:snowflake');

    return (
        <div className={styles.userInfoHeader}>
            <Icon variant="snowflake-strong" size={IconSize.LARGE} />
            <div className={styles.userInfo}>
                <span className={styles.user}>{user ?? userFallback}</span>
                {account && <span className={styles.account}>@{account}</span>}
            </div>
        </div>
    );
}

SnowflakeUserInfo.propTypes = {
    account: PropTypes.string,
    user: PropTypes.string
};
